import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-doc-connector-history-response-dialog',
  templateUrl: './doc-connector-history-response-dialog.component.html',
  styleUrls: ['./doc-connector-history-response-dialog.component.scss']
})
export class DocConnectorHistoryResponseDialogComponent implements OnInit {
  responseTable = [];
  displayedColumns = ['fileName', 'source', 'destiantion', 'statusMessage'];
  constructor(
    public dialogRef: MatDialogRef<DocConnectorHistoryResponseDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public responseMessages: any
  ) {}

  ngOnInit(): void {
    console.log(this.responseMessages);
  }
}
